import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/opportunities/public')({
  component: () => <Outlet />,
  staticData: {
    breadcrumbLabel: '公開オポチュニティ一覧',
  },
})
